import { useState, useEffect } from 'react';

import { Box, Grid } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import AddAccountModal from '../../components/Modals/PermissionsManagement/AddAccountModal';
import ManageAccountModal from '../../components/Modals/PermissionsManagement/ManageAccountModal';
import DeleteUserModal from '../../components/Modals/PermissionsManagement/DeleteUserModal';
import { Button } from '../../components/common';
import DataGrid from '../../components/DataGrid/DataGrid';
import { columns } from './permissionsManagementConsts';
import { admin } from '../../utils/api';

export default function PermissionsManagement(props) {
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openManageModal, setOpenManageModal] = useState(false);
  const [openDeleteUserModal, setOpenDeleteUserModal] = useState(false);
  const [data, setData] = useState();
  const [selection, setSelection] = useState([]);
  const [selectionData, setSelectionData] = useState([]);
  const [currentlySelected, setCurrentlySelected] = useState(0);

  const updateUsers = async () => {
    await admin
      .getUsers()
      .then((result) => {
        setData(result.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    updateUsers();
  }, []);

  const handleOpenManage = () => {
    setCurrentlySelected(0);
    setOpenManageModal(true);
  };

  const handleDelete = () => {
    setOpenManageModal(false);
    setOpenDeleteUserModal(true);
  };

  const handleBack = () => {
    setOpenManageModal(true);
    setOpenDeleteUserModal(false);
  };

  const handleSelectionChange = (newSelection) => {
    setSelection(newSelection);
    const selectionDataFiltered = data?.filter((plot) => {
      if (newSelection.includes(plot.id)) return plot;
      else return null;
    });
    setSelectionData(selectionDataFiltered);
  };

  return (
    <>
      <Box sx={{ mt: 10 }}>
        <Grid container direction="column">
          <Grid item xs={6} sx={{ mb: 3 }}>
            <Button variant="contained" onClick={() => setOpenAddModal(true)}>
              <PersonAddIcon sx={{ mr: 2 }} />
              DODAJ NOWE KONTO
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              onClick={handleOpenManage}
              disabled={!(selection.length > 0)}
            >
              <ManageAccountsIcon sx={{ mr: 2 }} />
              ZARZĄDZAJ KONTEM
            </Button>
          </Grid>
        </Grid>

        <DataGrid
          toolbar
          checkboxSelection
          multiselect={false}
          columnData={columns}
          rowData={data?.sort((a, b) => a.id - b.id)}
          sx={{ boxShadow: 3 }}
          onSelectionModelChange={handleSelectionChange}
          selectionModel={selection}
          getRowHeight={() => 'auto'}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      </Box>
      {openAddModal && (
        <AddAccountModal
          open={openAddModal}
          setOpen={setOpenAddModal}
          update={updateUsers}
        />
      )}
      {openManageModal && (
        <ManageAccountModal
          open={openManageModal}
          setOpen={setOpenManageModal}
          handleDelete={handleDelete}
          update={updateUsers}
          selected={selection}
          data={selectionData}
          currentlySelected={currentlySelected}
          setCurrentlySelected={setCurrentlySelected}
        />
      )}
      {openDeleteUserModal && (
        <DeleteUserModal
          open={openDeleteUserModal}
          setOpen={setOpenDeleteUserModal}
          handleBack={handleBack}
          update={updateUsers}
          currentID={selectionData[currentlySelected].id}
        />
      )}
    </>
  );
}
